import styled from "styled-components";
const ColumnFocusWrapper = styled.div`
  pointer-events: none;
  position: absolute;
  inset: 0;
  z-index: 99;
  width: ${(props) => props.width}px;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: ${(props) => props.leftOffset}px;
    right: 0;
    height: 2px;
    background-color: ${(props) => props.theme.column.selected.borderColor};
    opacity: 0.8;
  }
`;
export {
  ColumnFocusWrapper
};
